import { NORMALIZED_STAGE } from 'src/constants/EnvironmentConstants';
import { getBrowserInfo } from 'src/utilities/ClientEnvUtils';

const CHROME_INSTALL_URL = 'https://chromewebstore.google.com/detail/ask-rino/dookghbpeoadopcgogogadnookgalogb?authuser=0&hl=en';
const FIREFOX_INSTALL_URL = 'https://askrino-extension.dkgprod.fgbs.amazon.dev/ask-rino-firefox.xpi';

function getInstallUrl(): string {
  const { name } = getBrowserInfo();
  return name === 'Firefox' ? FIREFOX_INSTALL_URL : CHROME_INSTALL_URL;
}

export const ASK_RINO_CONFIG = {
  installUrl: getInstallUrl(),
  stage: NORMALIZED_STAGE
};
